/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef, useState } from "react";
import ic_big_cirlce_person from "../../assets/images/pictures/icon/ic_person_big_circle.svg";
import identity_header from "../../assets/images/pictures/identity_header-1.png";
import ic_lock_circle from "../../assets/images/pictures/icon/ic_lock_circle.svg";
import ic_cycle_circle from "../../assets/images/pictures/icon/ic_cycle_circle.svg";
import ic_search_customer_circle from "../../assets/images/pictures/icon/ic_search_customer_circle.svg";
import ic_cost_circle from "../../assets/images/pictures/icon/ic_cost_circle.svg";
import ic_big_circle_globe from "../../assets/images/pictures/icon/ic_globe_big_circle.svg";
import ic_flag from "../../assets/images/pictures/icon/ic_flag.svg";
import ic_light_bulb from "../../assets/images/pictures/icon/ic-lightbulb-outline-black-24-px.svg";
import ic_big_circle_key from "../../assets/images/pictures/icon/ic_key_big_circle.svg";
import identity_gateway from "../../assets/images/pictures/identity_gateway-en.png";
import identity_api from "../../assets/images/pictures/identity_api.png";
import ic_person_circle from "../../assets/images/pictures/icon/ic_person_circle.svg";
import ic_person_code_circle from "../../assets/images/pictures/icon/ic_person-code_circle.svg";
import ic_person_circle_small from "../../assets/images/pictures/icon/ic_person_small_circle.svg";
import ic_person_code_circle_small from "../../assets/images/pictures/icon/ic_person-code_small_circle.svg";
import gopaperless_service from "../../assets/images/pictures/solutions-footer.png";
import ic_download_white from "../../assets/images/pictures/icon/ic_download-white.svg";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";
import routeVariants from "../../assets/animates/routeVariants";
import Modal from "../global/Modal";
import ck from "../../assets/images/logos/elden/ck.png";
import invl from "../../assets/images/logos/elden/invl.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EIdentificationApiContent = (props) => {
  const [modalGatewayOpen, setModalGatewayOpen] = useState(false);

  const [modalApiOpen, setModalApiOpen] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (
      modalOpen === true ||
      modalGatewayOpen === true ||
      modalApiOpen === true
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalOpen, modalGatewayOpen, modalApiOpen]);

  const modalRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setModalOpen(false);
      setModalApiOpen(false);
      setModalGatewayOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === "Escape") {
      setModalOpen(false);
      setModalApiOpen(false);
      setModalGatewayOpen(false);
    }
  };

  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    if (props.following === true) {
      document
        .getElementById("e-identification-api")
        .classList.add("active", "in");
    } else {
      document
        .getElementById("e-identification-api")
        .classList.remove("active", "in");
    }
  }, [props.following]);

  function handleOpenTableIdentification() {
    document.getElementById("table-identification-open").style.display =
      "block";
    document.getElementById("see-more-identification").style.display = "none";
  }

  return (
    <>
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        className="tab-pane fade"
        id="e-identification-api"
      >
        <div className="bg-color p-md-0 mb-100">
          <div className="container pt-100 pb-100">
            <div className="row api-solutions">
              <div className="col-sm-6 pl-md-0">
                <img
                  width="64"
                  height="64"
                  src={ic_big_cirlce_person}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold pr-50">
                  {t(
                    "e-identification-api-page.e-identification-api-page-content.content-1.heading"
                  )}
                </h2>
                <div className="subheading">
                  <p>
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-1.description"
                    )}
                  </p>
                </div>
                <ul className="list-inline">
                  <li>
                    <img
                      className="client-s-none-width img-bw"
                      src={ck}
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      className="client-s-none-width img-bw"
                      src={invl}
                      alt=""
                    />
                  </li>
                </ul>
              </div>
              <div className="col-sm-6 pr-md-0">
                <img
                  src={identity_header}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container api-solutions m-50">
          <div className="row">
            <div className="col-sm-12 px-md-0">
              <div className="rectangle"></div>
              <h2 className="font-weight-bold">
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.big-heading"
                )}
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 mb-30 pl-md-0">
              <img
                width="40"
                height="40"
                src={ic_lock_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h3>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-heading-1"
                )}
              </h3>
              <p>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-description-1"
                )}
              </p>
            </div>
            <div className="col-sm-6 mb-30 pr-md-0">
              <img
                width="40"
                height="40"
                src={ic_cycle_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h3>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-heading-2"
                )}
              </h3>
              <p>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-description-2"
                )}
              </p>
            </div>
            <div className="col-sm-6 mb-30 pl-md-0">
              <img
                width="40"
                height="40"
                src={ic_search_customer_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h3>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-heading-3"
                )}
              </h3>
              <p>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-description-3"
                )}
              </p>
            </div>
            <div className="col-sm-6 mb-30 pr-md-0">
              <img
                width="40"
                height="40"
                src={ic_cost_circle}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h3>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-heading-4"
                )}
              </h3>
              <p>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-2.small-description-4"
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="py-100 mt-100 bg-color">
          <div className="container px-md-0 ">
            <div className="row api-solutions flex v-align">
              <div className="col-sm-6">
                <img
                  width="64"
                  height="64"
                  src={ic_big_circle_globe}
                  className="attachment-full size-full"
                  alt=""
                  decoding="async"
                  loading="lazy"
                  data-no-retina=""
                />
                <h2 className="heading font-weight-bold">
                  {t(
                    "e-identification-api-page.e-identification-api-page-content.content-3.big-heading"
                  )}
                </h2>
                <p className="subheading">
                  {t(
                    "e-identification-api-page.e-identification-api-page-content.content-3.big-description"
                  )}
                </p>
                <div className="icon-left-box">
                  <aside>
                    <img
                      width="24"
                      height="24"
                      src={ic_flag}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                  </aside>
                  <section>
                    <h5>
                      {t(
                        "e-identification-api-page.e-identification-api-page-content.content-3.small-heading-1"
                      )}
                    </h5>
                    <p>
                      {t(
                        "e-identification-api-page.e-identification-api-page-content.content-3.small-description-1"
                      )}
                    </p>
                  </section>
                </div>
                <div className="icon-left-box">
                  <aside>
                    <img
                      width="24"
                      height="24"
                      src={ic_light_bulb}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                  </aside>
                  <section>
                    <h5>
                      {t(
                        "e-identification-api-page.e-identification-api-page-content.content-3.small-heading-2"
                      )}
                    </h5>
                    <p>
                      {t(
                        "e-identification-api-page.e-identification-api-page-content.content-3.small-description-2"
                      )}
                      <a href="/eids">
                        {t(
                          "e-identification-api-page.e-identification-api-page-content.content-3.small-description-2-1"
                        )}
                      </a>
                    </p>
                  </section>
                </div>
              </div>
              <div className="col-sm-6 m-auto">
                <img
                  src={require("../../assets/images/pictures/southeast_asia_map_4.png")}
                  className="img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-100">
          <div className="row api-solutions">
            <div className="col-sm-6 col-sm-offset-3 text-center">
              <img
                width="64"
                height="64"
                src={ic_big_circle_key}
                className="attachment-full size-full"
                alt=""
                decoding="async"
                loading="lazy"
                data-no-retina=""
              />
              <h2 className="heading font-weight-bold">
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-4.big-heading"
                )}
              </h2>
              <p className="subheading mb-50">
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-4.big-description"
                )}
              </p>
            </div>
          </div>
          <div className="row api-solutions flex">
            <div className="col-sm-6 flex pl-md-0">
              <div className="card">
                <div className="card__header">
                  <img
                    width="437"
                    height="140"
                    src={identity_gateway}
                    className="img-responsive"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />
                </div>
                <div className="card__body">
                  <img
                    width="40"
                    height="40"
                    src={ic_person_circle}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  <h3>
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-4.small-heading-1"
                    )}
                  </h3>
                  <p>
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-4.small-description-1"
                    )}
                  </p>
                  <div className="btns-inline">
                    <p>
                      <a href="javascript:;">
                        {t(
                          "e-identification-api-page.e-identification-api-page-content.content-4.small-link-1"
                        )}
                      </a>
                    </p>
                    <p>
                      <a href="javascript:;">
                        {t(
                          "e-identification-api-page.e-identification-api-page-content.content-4.small-link-2"
                        )}
                      </a>
                    </p>
                  </div>
                  <a
                    href="javascript:;"
                    onClick={() => setModalGatewayOpen(true)}
                    className="btn-secondary"
                  >
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-4.button-contact-us"
                    )}
                  </a>
                </div>
              </div>
            </div>

            <div className="col-sm-6 flex pr-md-0">
              <div className="card">
                <div className="card__header">
                  <img
                    width="373"
                    height="194"
                    src={identity_api}
                    className="img-responsive"
                    alt=""
                    decoding="async"
                    loading="lazy"
                  />{" "}
                </div>
                <div className="card__body">
                  <img
                    width="40"
                    height="40"
                    src={ic_person_code_circle}
                    className="attachment-full size-full"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />{" "}
                  <h3>
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-4.small-heading-2"
                    )}
                  </h3>
                  <p>
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-4.small-description-2"
                    )}
                  </p>
                  <div className="btns-inline">
                    <p>
                      <a href="javascript:;">
                        {t(
                          "e-identification-api-page.e-identification-api-page-content.content-4.small-link-1"
                        )}
                      </a>
                    </p>
                    <p>
                      <a href="javascript:;">
                        {t(
                          "e-identification-api-page.e-identification-api-page-content.content-4.small-link-2"
                        )}
                      </a>
                    </p>
                  </div>
                  <a
                    href="javascript:;"
                    onClick={() => setModalApiOpen(true)}
                    className="btn-secondary"
                  >
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-4.button-contact-us"
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container api-solutions block-more-detailed px-md-0"
          id="see-more-identification"
        >
          <div className="row flex center braker-box">
            <div className="braker-box__line ">
              <hr />
            </div>
            <div className="text-center braker-box__text">
              <p>
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-5.description-1"
                )}
              </p>
              <a
                className="link-more-detailed"
                href="javacript:;"
                onClick={handleOpenTableIdentification}
              >
                {t(
                  "e-identification-api-page.e-identification-api-page-content.content-5.description-2"
                )}
              </a>
            </div>
            <div className="braker-box__line">
              <hr />
            </div>
          </div>
        </div>

        {language === "en" ? (
          <div
            className="container table-more-detailed px-md-0"
            id="table-identification-open"
          >
            <div className="table-comparison mobile-hidden">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__header"></div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Identity Gateway:
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_code_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Identity API:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Embedded login</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Provide a unified login experience by embedding the
                      solution right into your website or app.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Get more flexibility to create a desirable login
                      experience by yourself.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Supported eIDs</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Configure any eID you want to enable for your customers
                      with a click of a button. No separate integrations of
                      different eIDs are required.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Each eID you want to support in your system needs to be
                      integrated separately.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Localisation</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Set UI to GoPaperless supported languages: English,
                      Vietnamese. More languages are coming soon.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Each language you want to support in your system needs to
                      be localised separately.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>UI and branding</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Easily customise what Gateway looks like by applying
                      custom styles using CSS and Javascript.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Build your own UI by developing all the necessary elements
                      by yourself.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-comparison table-comparison--mobile">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Identity Gateway:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Embedded login</p>
                    </div>
                    <p>
                      Provide a unified login experience by embedding the
                      solution right into your website or app.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Supported eIDs</p>
                    </div>
                    <p>
                      Configure any eID you want to enable for your customers
                      with a click of a button. No separate integrations of
                      different eIDs are required.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Localisation</p>
                    </div>
                    <p>
                      Set UI to GoPaperless supported languages: English,
                      Vietnam. More languages are coming soon.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>UI and branding</p>
                    </div>{" "}
                    <p>
                      Easily customise what Gateway looks like by applying
                      custom styles using CSS and Javascript.
                    </p>
                  </div>
                </div>
              </div>

              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_code_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    With Identity API:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Embedded login</p>
                    </div>
                    <p>
                      Get more flexibility to create a desirable login
                      experience by yourself.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Supported eIDs</p>
                    </div>
                    <p>
                      Each eID you want to support in your system needs to be
                      integrated separately.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Localisation</p>
                    </div>
                    <p>
                      Each language you want to support in your system needs to
                      be localised separately.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>UI and branding</p>
                    </div>
                    <p>
                      Build your own UI by developing all the necessary elements
                      by yourself.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="container table-more-detailed px-md-0"
            id="table-identification-open"
          >
            <div className="table-comparison mobile-hidden">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__header"></div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với cổng nhận dạng:
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_code_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với API nhận dạng:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Đăng nhập nhúng</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Cung cấp trải nghiệm đăng nhập thống nhất bằng cách nhúng
                      giải pháp ngay vào trang web hoặc ứng dụng của bạn.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Linh hoạt hơn để tự mình tạo trải nghiệm đăng nhập mong
                      muốn.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Những eID được hỗ trợ</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Định cấu hình bất kỳ eID nào bạn muốn kích hoạt cho khách
                      hàng của mình chỉ bằng một nút bấm. Không yêu cầu tích hợp
                      riêng biệt các eID khác nhau.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Mỗi eID bạn muốn hỗ trợ trong hệ thống của mình cần được
                      tích hợp riêng.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Nội địa hóa</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Đặt giao diện người dùng thành Ngôn ngữ hỗ trợ của
                      GoPaperless: tiếng Anh, tiếng Việt. Nhiều ngôn ngữ đang
                      được phát triển.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Mỗi ngôn ngữ bạn muốn hỗ trợ trong hệ thống của mình cần
                      được nội địa hóa riêng.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-1">
                  <div className="table-comparison__body">
                    <p>Giao diện người dùng và thương hiệu</p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Dễ dàng tùy chỉnh giao diện của Cổng bằng cách áp dụng các
                      kiểu tùy chỉnh bằng CSS và Javascript.
                    </p>
                  </div>
                </div>
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <p>
                      Xây dựng giao diện người dùng của riêng bạn bằng cách tự
                      mình phát triển tất cả các yếu tố cần thiết.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-comparison table-comparison--mobile">
              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với cổng nhận dạng:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Đăng nhập nhúng</p>
                    </div>
                    <p>
                      Cung cấp trải nghiệm đăng nhập thống nhất bằng cách nhúng
                      giải pháp ngay vào trang web hoặc ứng dụng của bạn.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Những eID được hỗ trợ</p>
                    </div>
                    <p>
                      Định cấu hình bất kỳ eID nào bạn muốn kích hoạt cho khách
                      hàng của mình chỉ bằng một nút bấm. Không yêu cầu tích hợp
                      riêng biệt các eID khác nhau.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Nội địa hóa</p>
                    </div>
                    <p>
                      Đặt giao diện người dùng thành Ngôn ngữ được hỗ trợ của
                      GoPaperless: tiếng Anh, tiếng Việt. Nhiều ngôn ngữ đang
                      được phát triển.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Giao diện người dùng và thương hiệu</p>
                    </div>
                    <p>
                      Dễ dàng tùy chỉnh giao diện của Cổng bằng cách áp dụng các
                      kiểu tùy chỉnh bằng CSS và Javascript.
                    </p>
                  </div>
                </div>
              </div>

              <div className="table-comparison__row table-comparison__row--header">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__header">
                    <img
                      width="30"
                      height="30"
                      src={ic_person_code_circle_small}
                      className="attachment-full size-full"
                      alt=""
                      decoding="async"
                      loading="lazy"
                      data-no-retina=""
                    />
                    Với API nhận dạng:
                  </div>
                </div>
              </div>

              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Đăng nhập nhúng</p>
                    </div>
                    <p>
                      Linh hoạt hơn để tự mình tạo trải nghiệm đăng nhập mong
                      muốn.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Những eID được hỗ trợ</p>
                    </div>
                    <p>
                      Mỗi eID bạn muốn hỗ trợ trong hệ thống của mình cần được
                      tích hợp riêng.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Nội địa hóa</p>
                    </div>
                    <p>
                      Mỗi ngôn ngữ bạn muốn hỗ trợ trong hệ thống của mình cần
                      được nội hóa riêng.
                    </p>
                  </div>
                </div>
              </div>
              <div className="table-comparison__row">
                <div className="table-comparison__col-2">
                  <div className="table-comparison__body">
                    <div className="table-comparison__mobile-header">
                      <p>Giao diện người dùng và thương hiệu</p>
                    </div>
                    <p>
                      Xây dựng giao diện người dùng của riêng bạn bằng cách tự
                      mình phát triển tất cả các yếu tố cần thiết.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="api-solutions bg-color--img-overlap mt-50 bg-color">
          <div className="container identification-footer">
            <div className="row">
              <div className="col-sm-6 pl-md-0">
                <h2 className="heading font-weight-bold">
                  {t(
                    "e-identification-api-page.e-identification-api-page-content.content-6.heading"
                  )}
                </h2>
                <div className="subheading">
                  <p>
                    {t(
                      "e-identification-api-page.e-identification-api-page-content.content-6.description"
                    )}
                  </p>
                </div>
                <a                 href="/uploads/BẢNG GIÁ DỊCH VỤ GOPAPERLESS.pdf"
  download="BẢNG GIÁ DỊCH VỤ GOPAPERLESS.pdf" className="btn-primary mr-16">
                  <img
                    width="18"
                    height="18"
                    src={ic_download_white}
                    className="attachment-full size-full mt--3 mr-5"
                    alt=""
                    decoding="async"
                    loading="lazy"
                    data-no-retina=""
                  />
                  {t(
                    "e-identification-api-page.e-identification-api-page-content.content-6.button-download-pricing"
                  )}
                </a>

                <a
                  href="javascript:;"
                  onClick={() => setModalOpen(true)}
                  className="btn-secondary"
                >
                  {t(
                    "e-identification-api-page.e-identification-api-page-content.content-6.button-contact-us"
                  )}
                </a>
              </div>
              <div className="col-sm-6 pl-md-0">
                <img
                  src={gopaperless_service}
                  width="400px"
                  className="bg-color--img-overlap__img img-responsive"
                  alt=""
                  decoding="async"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      {modalOpen && (
        <Modal
          setOpenModal={setModalOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-found-solution-fit")}
          description={t("modal.description-get-started")}
          type="Solutions - E Identification API - Electronic identity in your e-service"
        />
      )}
      {modalGatewayOpen && (
        <Modal
          setOpenModal={setModalGatewayOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-identity-gateway")}
          description={t("modal.description-fillout-reach")}
          type="Solutions - E Identification API - Identity Gateway"
        />
      )}
      {modalApiOpen && (
        <Modal
          setOpenModal={setModalApiOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-identity-api")}
          description={t("modal.description-fillout-reach")}
          type="Solutions - E Identification API - Identity API"
        />
      )}
      <ToastContainer />
    </>
  );
};

export default EIdentificationApiContent;
